export enum CompletenessWeight {
    LOW = 1,
    MID = 2,
    MAX = 3
}

export type FieldDefinition = {
    name?: string
    mandatory?: boolean
    minLength?: number
    weight: CompletenessWeight
}

export type CompletenessErrors<T = any> = {
    [key in keyof T]?: any
}

export type CompletenessResult<T = any> = {
    isComplete: boolean
    errors: CompletenessErrors<T>
}

export type CompletenessRules<T = object> = {
    [key in keyof T]?: FieldDefinition
}

export const useCompleteness = () => {
    const evaluate = (data: any, rules: CompletenessRules): CompletenessResult => {
        const result = (Object.entries(rules) as [string, FieldDefinition][]).map(([attr, definition]) => {
            let error
            const value = data?.[attr]
            if (definition.mandatory) {
                if (!value) {
                    error = 'Povinný údaj'
                } else if (value instanceof Array && value.length === 0) {
                    error = 'Povinný údaj'
                } else if (typeof value === 'string') {
                    if (value && definition.minLength && value.length < definition.minLength) {
                        error = `Minimálna dlžka hodnoty je ${definition.minLength}`
                    }
                }
            }
            return { attr, errors: error }
        })

        const errors: CompletenessErrors = result
            .filter(({ errors }) => Boolean(errors))
            .reduce(
                (errorsByAttr, error) => ({
                    ...errorsByAttr,
                    [error.attr]: error.errors
                }),
                {}
            )
        return {
            isComplete: !Object.keys(errors).length,
            errors
        }
    }

    return {
        evaluate
    }
}
